import { apiClient } from "@/api/api-client";

export type BomItem = {
    id: number;
    item_name: string;
};

const bomItemService = {
    list: async (): Promise<BomItem[]> => {
        const response = await apiClient.get<BomItem[]>("/bom/items");
        return response.data;
    },
};

export default bomItemService;
